import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API });

// Helpers used by UserContext
export const setAuthTokens = (access, refresh) => {
  if (access) localStorage.setItem("if_access_token", access);
  if (refresh) localStorage.setItem("if_refresh_token", refresh);
};
export const clearAuthTokens = () => {
  localStorage.removeItem("if_access_token");
  localStorage.removeItem("if_refresh_token");
};
export const getAccessToken = () => localStorage.getItem("if_access_token");
export const getRefreshToken = () => localStorage.getItem("if_refresh_token");

// Attach access token to every request
api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-refresh on 401 (single retry)
let refreshing = null;

api.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";
    const isAuthCall =
      url.includes("/users/login") ||
      url.includes("/users/register") ||
      url.includes("/auth/refresh") ||
      url.includes("/auth/logout");

    if (status === 401 && !original._retry && !isAuthCall) {
      original._retry = true;
      const refresh = getRefreshToken();
      if (!refresh) {
        clearAuthTokens();
        return Promise.reject(error);
      }
      try {
        if (!refreshing) {
          refreshing = axios.post(`${API}/auth/refresh`, { refresh_token: refresh })
            .then((r) => {
              setAuthTokens(r.data.access_token, r.data.refresh_token);
              return r.data.access_token;
            })
            .finally(() => { refreshing = null; });
        }
        const newToken = await refreshing;
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original);
      } catch (e) {
        clearAuthTokens();
        // bounce to login
        if (typeof window !== "undefined" && !window.location.pathname.startsWith("/auth")) {
          window.location.href = "/auth";
        }
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export const getWsUrl = (roomId) => {
  const wsBase = BASE.replace("https://", "wss://").replace("http://", "ws://");
  return `${wsBase}/api/ws/${roomId}`;
};
